import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { IconButton, IconClose16, ModalFullscreen, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IModalViewProps {
  isOpened: boolean;
  onClose(): void;
  offersTable: React.ReactElement;
  nearbyHousesInfo?: React.ReactElement;
  filters: React.ReactElement;
  offerFromHistory: React.ReactElement;
  onView(): void;
  title: string;
}

export const FullscreenView: React.FC<IModalViewProps> = ({
  isOpened,
  onClose,
  offersTable,
  nearbyHousesInfo,
  filters,
  offerFromHistory,
  onView,
  title,
}) => {
  return (
    <ModalFullscreen open={isOpened} onClose={onClose} theme="white">
      <ActionAfterViewObserver callback={onView} callbackDelay={1500} wrapper={false}>
        <div className={styles['container']} data-testid="offers_history_fullscreen_view">
          <header className={styles['header']}>
            <UIText1 fontWeight="bold">{title}</UIText1>
            <IconButton icon={<IconClose16 />} onClick={onClose} data-testid="offers_history_fullscreen_close" />
          </header>
          <div className={styles['main']}>
            <div className={styles['listing']}>
              {filters}
              {nearbyHousesInfo}
              <div data-testid="MoreDetailed" className={styles['sc_info']}>
                <UIText2>
                  <a href="https://support.cian.ru/ru/knowledge_base/art/181/cat/30/" target="_blank" rel="noreferrer">
                    Как работать с историей объявлений
                  </a>
                </UIText2>
              </div>
              <div className={styles['table']}>{offersTable}</div>
            </div>
            <div className={styles['offer']}>{offerFromHistory}</div>
          </div>
        </div>
      </ActionAfterViewObserver>
    </ModalFullscreen>
  );
};
